import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {reduxForm, Field, formValueSelector} from 'redux-form';
import {connect} from 'react-redux';
import {injectIntl, intlShape} from 'react-intl';
import classNames from 'classnames';

import {otpLogin, otpResendPassword, otpResendTimerTick} from '../actions/auth';
import FlashMessage from '../components/FlashMessage';
import TextInput from '../components/Form/TextInput';
import validate from '../validators/forms/otp';
import AppBlock from '../components/AppBlock';

const FORM_NAME = 'otp-form';

const CODE_LENGTH = 6;

class OTPForm extends Component {
  constructor(props) {
    super(props);

    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleResend = this.handleResend.bind(this);
  }

  handleFormSubmit(values) {
    otpLogin(this.props.dispatch, values, this.props.location.query);
  }

  handleResend() {
    if (this.props.timer === 0) {
      const {
        dispatch,
        xl: {
          localization: {locale}
        },
        location: {
          query: {challenge_id}
        }
      } = this.props;

      otpResendPassword(dispatch, {challenge_id, locale});

      this.interval_id = setInterval(() => {
        if (this.props.timer) {
          otpResendTimerTick(dispatch);
        } else {
          clearInterval(this.interval_id);
        }
      }, 1000);
    }
  }

  render() {
    const {
      intl,
      timer,
      codeValue,
      auth: {otp},
      handleSubmit,
      location: {
        query: {email}
      }
    } = this.props;

    const enabledResend = timer === 0;
    const hasError = otp.error !== null || otp.resend.error !== null;
    const errorCode = otp.error || otp.resend.error;
    const errorMessage = intl.messages[errorCode] || errorCode;

    return (
      <AppBlock>
        <div className="block-content otp-page">
          {hasError && <FlashMessage type="error" message={errorMessage} />}
          <form onSubmit={handleSubmit(this.handleFormSubmit)}>
            <div className="form-group content-message">
              {intl.formatMessage({id: 'otp.message'}, {email})}
            </div>
            <Field
              component={TextInput}
              autoFocus={true}
              parse={value =>
                value
                  .split('')
                  .filter(ch => /\d/.test(ch))
                  .join('')
              }
              maxLength={CODE_LENGTH}
              autoComplete="off"
              name="code"
            />
            <button
              type="submit"
              className="form-button button-with-bg"
              disabled={otp.loading || codeValue.length < CODE_LENGTH}
            >
              {intl.messages['form.signin']}
            </button>
            <a
              id="resend-button"
              className={classNames(
                'form-button',
                'button-link',
                {
                  'button-link_active': enabledResend
                },
                'resend-button'
              )}
              onClick={this.handleResend}
            >
              {timer
                ? intl.formatMessage({id: 'otp.resend.timer'}, {timer})
                : intl.messages['otp.resend.code']}
            </a>
          </form>
        </div>
      </AppBlock>
    );
  }
}

OTPForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  intl: intlShape,
  timer: PropTypes.number.isRequired,
  xl: PropTypes.object.isRequired,
  codeValue: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  return {
    timer: state.auth.otp.resend.timer,
    ...state,
    ...validate(),
    codeValue: formValueSelector(FORM_NAME)(state, 'code') || '',
    form: FORM_NAME
  };
}

export default injectIntl(connect(mapStateToProps)(reduxForm()(OTPForm)));



// WEBPACK FOOTER //
// ./pages/OTP.jsx